import { initializeAxiosBaseQuery } from '@gasbi/shared/common/utils/axiosBaseQuery';

import http from '@/utils/http';

const fabric = initializeAxiosBaseQuery(http);

// The agents slice passes the base URL the stream uses too ('/agents'). Relative, it would be appended to the axios
// instance's own baseURL ('/agents/agents/...'); absolute, it replaces it.
const toAbsolute = (url: string) =>
  url.startsWith('/') ? window.location.origin + url : url;

const axiosBaseQuery: typeof fabric = options =>
  fabric({ ...options, baseUrl: toAbsolute(options?.baseUrl ?? '') });

export default axiosBaseQuery;
